/** Marcas de motocicletas comunes en Colombia y Venezuela. */
export const KNOWN_MOTORCYCLE_BRANDS = [
  "AKT",
  "Aprilia",
  "Auteco",
  "Bajaj",
  "Benelli",
  "Bera",
  "BMW Motorrad",
  "CFMOTO",
  "Ducati",
  "Empire Keeway",
  "Forza",
  "Harley-Davidson",
  "Hero",
  "Honda",
  "Husqvarna",
  "Italika",
  "Kawasaki",
  "Keeway",
  "KTM",
  "Kymco",
  "Lifan",
  "Loncin",
  "Mahindra",
  "Moto Guzzi",
  "MV Agusta",
  "Piaggio",
  "Royal Enfield",
  "Suzuki",
  "SYM",
  "Triumph",
  "TVS",
  "UM",
  "Vespa",
  "Victory",
  "Voge",
  "Yamaha",
  "Yadea",
  "Zontes",
];

export function buildModelYearSuggestions(fromYear = 2000) {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear; year >= fromYear; year -= 1) {
    years.push(String(year));
  }
  return years;
}

export function mergeUniqueSuggestions(...lists) {
  const seen = new Set();
  const merged = [];

  lists.flat().forEach((item) => {
    const value = String(item || "").trim();
    if (!value) return;
    const key = value.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    merged.push(value);
  });

  return merged;
}

export function filterSuggestions(items, query, limit = 12) {
  const normalizedQuery = (query || "").trim().toLowerCase();
  const source = items || [];

  if (!normalizedQuery) {
    return source.slice(0, limit);
  }

  return source
    .filter((item) => item.toLowerCase().includes(normalizedQuery))
    .slice(0, limit);
}
